module.exports = __webpack_public_path__ + "img/icono.177bdbff.svg";